import setAttribute from 'utils/DOM/setAttribute'
import getPremium from 'core/controllerPlans/getPremium'
import moneyFormat from 'utils/format/money'
import getById from 'utils/DOM/getById'

const asMoney = moneyFormat

function prepareDataToTrack(planId, state) {
  const placementMainPlan = 'main-plan'
  const placementDentalAddon = 'dental-addon'
  const placementLatitudeAddon = 'latitude-addon'
  const placementPlanSummary = 'plan-summary'
  const planValue = 'plan-' + planId

  setAttribute('#plan-card__details-control', 'data-sp-value', planValue)
  setAttribute('#plan-card__details-control', 'data-placement', placementMainPlan)
  setAttribute('#details-link--plan-details', 'data-sp-value', planValue)
  setAttribute('#details-link--plan-details', 'data-placement', placementMainPlan)
  setAttribute('#brochure-link', 'data-sp-value', planValue)
  setAttribute('#brochure-link', 'data-placement', placementMainPlan)

  setAttribute('#dental-actions', 'data-placement', placementDentalAddon)
  setAttribute('#dental-brochure', 'data-sp-value', 'dental-brochure')
  setAttribute('#dental-brochure', 'data-placement', placementDentalAddon)
  setAttribute('#find-dentist', 'data-sp-value', 'find-dentist')
  setAttribute('#find-dentist', 'data-placement', placementDentalAddon)
  setAttribute('#vision-providers', 'data-sp-value', 'vision-providers')
  setAttribute('#vision-providers', 'data-placement', placementDentalAddon)

  setAttribute('#latitude-brochure', 'data-sp-value', 'latitude-brochure')
  setAttribute('#latitude-brochure', 'data-placement', placementLatitudeAddon)

  setAttribute(
    '#extended-plan',
    'data-sp-value',
    planId + '-' + state.period + '-' + state.maxPolicies
  )
  setAttribute('#extended-plan', 'data-placement', placementPlanSummary)

  setAttribute('.coverage-period__edit', 'data-sp-value', planValue)
  setAttribute('.coverage-period__edit', 'data-placement', placementPlanSummary)
  setAttribute('#sdate', 'data-sp-value', planValue)
  setAttribute('#sdate', 'data-placement', placementPlanSummary)
  setAttribute('#endDate', 'data-sp-value', planValue)
  setAttribute('#endDate', 'data-placement', placementPlanSummary)
  setAttribute('#period', 'data-sp-value', planValue)
  setAttribute('#period', 'data-placement', placementPlanSummary)
  setAttribute('.coverage-period__save', 'data-sp-value', planValue)
  setAttribute('.coverage-period__save', 'data-placement', placementPlanSummary)

  setAttribute('.js-addon-delete', 'data-sp-value', 'delete-dental-addon')
  setAttribute('.js-addon-delete', 'data-placement', placementPlanSummary)
  setAttribute('.js-latitude-delete', 'data-sp-value', 'delete-latitude-addon')
  setAttribute('.js-latitude-delete', 'data-placement', placementPlanSummary)

  setAttribute('#eligibility-link--sticky', 'data-sp-value', planValue)
  setAttribute('#eligibility-link--sticky', 'data-placement', placementPlanSummary)
}

function updateDentalControl(id, state, isVisionChecked) {
  const isSelected = state.addOns.indexOf(id) !== -1
  const dentalPremium = getPremium(state.plans[id])
  const visionPremium = isVisionChecked ? getPremium(state.plans[14]) : 0

  let planName = state.plans[id].planName
  planName = !isVisionChecked ? planName : planName + '+Vision'

  let value = !isSelected ? 'add-' : 'remove-'
  value += +id + '-' + planName + '-' + asMoney(dentalPremium + visionPremium)
  getById('add-on-input-' + id).setAttribute('data-sp-value', value)
}

function updateVisionControl(visionPlan, isVisionChecked) {
  const visionPremium = asMoney(getPremium(visionPlan))

  let value = isVisionChecked ? 'remove-vision-' : 'add-vision-'
  value += visionPremium

  setAttribute('#dental-actions', 'data-sp-value', value)
}

function updateLatitudeControl(id, state) {
  const isSelected = state.addOns.indexOf(id) !== -1

  let value = !isSelected ? 'add-' : 'remove-'
  value +=
    +id + '-' + state.plans[id].planName + '-' + asMoney(getPremium(state.plans[id]))

  getById('add-on-input-' + id).setAttribute('data-sp-value', value)
}

export {
  prepareDataToTrack,
  updateDentalControl,
  updateVisionControl,
  updateLatitudeControl
}
